import { Component, Injectable, OnInit } from '@angular/core';
import { AuthService } from '../../../authentication/services/auth.service';
import { AlertService } from '../../../shared/alert/services/alert.service';
import { UrlService } from '../../../shared/services/url.service';
import { SentimentGroup } from '../../model/sentimentgroup';
import { SentimentService } from '../../services/sentiment.service';
import { SentimentGroupService } from '../../services/sentimentgroup.service';

@Component({
  selector: 'app-sentimentFilter',
  templateUrl: '../templates/sentimentFilter.component.html'
})

@Injectable()
export class SentimentFilterComponent implements OnInit {

  title = 'Sentiment Filter';
  DashboardUrl = '';
  Items: any[] = [];
  CurrentLanguage: string;
  IsActiveFilter: boolean = true;
  IsBullishFilter: boolean = true;
  SentimentGroupIdFilter: string = null;
  SentimentGroups: SentimentGroup[] = [];

  constructor(
    private urlService: UrlService,
    private alertService: AlertService,
    private authService: AuthService,
    private sentimentService: SentimentService,
    private sentimentGroupService: SentimentGroupService) {
  }

  ngOnInit() {
    this.DashboardUrl = this.urlService.GetDashboardRoute();
    this.CurrentLanguage = this.authService.getActualLanguage().cultureNameISO;
    this.sentimentGroupService.Get(this.CurrentLanguage)
      .subscribe(data => {
        this.SentimentGroups = data;
      });
  }

  Filter(): void {
    this.alertService.removeAll();
    this.Items = [];
    this.sentimentService.Get(this.CurrentLanguage, this.IsActiveFilter, this.SentimentGroupIdFilter, this.IsBullishFilter)
      .subscribe(data => {
        if (data.length > 0) {
          data.forEach(x => {
            var group = this.SentimentGroups.find(s => s.Id === x.SentimentGroupId);
            if (group) {
              x["SentimentGroupName"] = group.Name;
            }
            this.Items.push(x);
          });
        }
    });
  }

  onChange(sentiment): void {
    this.sentimentService.Put(this.CurrentLanguage, sentiment.Id, sentiment)
        .subscribe(() => this.alertService.add('success', 'Sentiment successfully edited'));
  }
}



// WEBPACK FOOTER //
// ./src/app/sentiment/components/scripts/sentimentFilter.component.ts